export enum Round {
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
  Finished = 'FINISHED',
  Expired = 'EXPIRED',
}
